module.exports = __webpack_public_path__ + "img/select-img-1.a7ce6e3b.png";